import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weituoyewuleixing",
  "use": "icon-weituoyewuleixing-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-weituoyewuleixing\"><path d=\"M1.611 9.39A5.49 5.49 0 01.116 4.377a1.156 1.156 0 011.954-.579l1.379 1.379c.475.475 1.25.475 1.726 0a1.223 1.223 0 000-1.727L3.796 2.072A1.161 1.161 0 013.504.918c.122-.408.456-.714.87-.8a5.5 5.5 0 016.34 7.139l4.088 4.086a2.447 2.447 0 010 3.457 2.447 2.447 0 01-3.457 0l-4.087-4.087a5.527 5.527 0 01-2.948.159A5.508 5.508 0 011.61 9.39zm-.32-4.647a4.27 4.27 0 001.186 3.782 4.284 4.284 0 004.425 1.018 1.164 1.164 0 011.195.276l4.113 4.114c.476.475 1.251.475 1.727 0a1.223 1.223 0 000-1.726L9.823 8.095a1.164 1.164 0 01-.277-1.196 4.303 4.303 0 00.134-2.326 4.265 4.265 0 00-1.152-2.098 4.266 4.266 0 00-3.78-1.186l1.294 1.294a2.445 2.445 0 010 3.455 2.447 2.447 0 01-3.457 0L1.291 4.743z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/weituoyewuleixing.svg
// module id = 521
// module chunks = 4